import { InspectionDraftsClient } from "./inspectionDrafts.js";
/** Shop overhead (/expenses): monthly bills and one-time costs. Owner or expenses:manage only. */
export class OverheadClient extends InspectionDraftsClient {
    expenseBase(slug, id) {
        const base = `${this.siteBase(slug)}/expenses`;
        return id === undefined ? base : `${base}/${encodeURIComponent(id)}`;
    }
    async listExpenses(slug) {
        const res = await this.request("GET", this.expenseBase(slug), undefined, true);
        return res.expenses;
    }
    async createExpense(slug, input) {
        return this.request("POST", this.expenseBase(slug), input, true);
    }
    /** `updatedAt` required; 409 `stale_update` when changed. */
    async patchExpense(slug, id, input) {
        return this.request("PATCH", this.expenseBase(slug, id), input, true);
    }
    /** Removes an entry made by mistake. */
    async deleteExpense(slug, id) {
        await this.request("DELETE", this.expenseBase(slug, id), undefined, true);
    }
}
//# sourceMappingURL=overhead.js.map